import type { PokemonV2 } from '../pokemon/pokemon';
import {
  POKEMON_TYPE_WATER,
  POKEMON_TYPE_ELECTRIC,
  POKEMON_TYPE_FIRE,
  POKEMON_TYPE_ICE,
  type PokemonType,
} from '../types/type';
import {
  OFFENCE_ITEM_ID_AQUA_CASSETTE,
  OFFENCE_ITEM_ID_INAZUMA_CASSETTE,
  OFFENCE_ITEM_ID_BLAZE_CASSETTE,
  OFFENCE_ITEM_ID_FREEZE_CASSETTE,
} from '../types/item';

// テクノバスター（Techno Blast）のタイプを決定する
// - カセット系の持ち物を所持している場合、そのカセットに応じてタイプが変化する
// - カセットを所持していない場合は技の元タイプ（通常: ノーマル）のまま
export const resolveTechnoBlastMoveType = (
  pokemon: Pick<PokemonV2, 'selected_item_id'>,
): PokemonType | undefined => {
  switch (pokemon.selected_item_id) {
    case OFFENCE_ITEM_ID_AQUA_CASSETTE:
      return POKEMON_TYPE_WATER;
    case OFFENCE_ITEM_ID_INAZUMA_CASSETTE:
      return POKEMON_TYPE_ELECTRIC;
    case OFFENCE_ITEM_ID_BLAZE_CASSETTE:
      return POKEMON_TYPE_FIRE;
    case OFFENCE_ITEM_ID_FREEZE_CASSETTE:
      return POKEMON_TYPE_ICE;
    default:
      return undefined;
  }
};

